import React from 'react'
import { TableCell } from '@mui/material';
import { SkeletonLoading } from '@/main/components/shared/styles'
import * as S from './styles';

interface ISkeletonRowSupplierAssignedProps {
  numberColumns: number
}
function SkeletonRowSupplierAssigned({
  numberColumns
}: ISkeletonRowSupplierAssignedProps) {
  return (
    <S.SkeletonPartTableRow>
      {Array.from(new Array(numberColumns)).map((_, index) => (
        <TableCell key={`SkeletonRowSupplierAssigned-cell-${index}`}>
          <SkeletonLoading />
        </TableCell>
      ))}
    </S.SkeletonPartTableRow>
  )
}

export default SkeletonRowSupplierAssigned